import {
  Navigation,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { DashboardUserProfilePage } from "@nju/feature-portal-user";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function MyProfile() {
  return (
    <LayoutWrapper data-cy="client-dashboard">
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="gray">
        <RequiredDashboardData extendedMode="base">
          <Navigation title="mój profil" />
          <DashboardUserProfilePage />
        </RequiredDashboardData>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
